import { filtersToQueryString } from "../utils/post-filter";
import client from "./ApiService";

class HomepageService {
  constructor() {
    this.url = "/homepages";
  }
  get(filters = {}) {
    if (!filters._limit) {
      filters._limit = { fieldName: "_limit", value: 10 };
    }

    let queryString = filtersToQueryString(filters);

    if (queryString.indexOf("&") == 0) {
      queryString = queryString.replace("&", "?");
    }
    return client.get(`${this.url}${queryString}`);
  }

  getByBtv(btvSlug){

  }

  update(params){
    return client.put(`${this.url}/${params.id}`, params);
  }
}

export default new HomepageService();
